/**
 * Nsection B1 Service
 * B.1.說明 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-b1';

export interface NsectionB1Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  ghg_mitigation_types: number[] | null;
  mitigation_outcome_type: number | null;
  is_reversal_risk: boolean;
  eligible_projects: string | null;
  nsection_b1_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB1Update {
  ghg_mitigation_types?: number[];
  mitigation_outcome_type?: number | null;
  is_reversal_risk?: boolean;
  eligible_projects?: string;
}

const nsectionB1Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB1Detail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },

  update: async (proposalId: number, data: NsectionB1Update): Promise<NsectionB1Detail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionB1Service;
